import React from 'react'
import { ReflectionTrack } from './ReflectionTrack.jsx'
import { SideQuestListCard } from './SideQuestListCard.jsx'
import { FreeTextCard } from './FreeTextCard.jsx'

const TAGS = ['FACT', 'VALUE', 'FUTURE', 'LEARNING']

const CARDS = [
  { key: 'card1', title: 'What did you work on that wasn\'t planned?', placeholder: 'Add the unplanned work that mattered this period.' },
  { key: 'card2', title: 'What value did this create?', placeholder: 'Who benefited? What shifted as a result?' },
  { key: 'card3', title: 'What future value does this unlock?', placeholder: 'Where could this go next? Is it worth continuing?' },
  { key: 'card4', title: 'What did you learn?', placeholder: 'What surprised you? What pattern do you notice?' },
]

export function SideQuestsTrack({
  data = {},
  onChange,
  managerNotes = {},
  onManagerNoteChange,
  createSuggestHandler,
  isReport,
  isManager,
  isShared,
  isReady,
  isClosed,
  reportName,
}) {
  const readOnly = isClosed || !isReport

  function countFilled() {
    let count = 0
    if (data.card1?.items?.length > 0) count++
    if (data.card2?.text) count++
    if (data.card3?.text) count++
    if (data.card4?.text) count++
    return count
  }

  function handleCardChange(cardKey, field, value) {
    const current = data[cardKey] || {}
    onChange?.({ ...data, [cardKey]: { ...current, [field]: value } })
  }

  return (
    <ReflectionTrack
      title="Side-quests"
      filledCount={countFilled()}
      sectionNote={managerNotes.section || ''}
      onSectionNoteChange={(v) => onManagerNoteChange?.({ ...managerNotes, section: v })}
      onSuggestSectionNote={createSuggestHandler?.('sideQuests', 'section')}
      isManager={isManager}
      isShared={isShared}
      isReady={isReady}
      isClosed={isClosed}
      reportName={reportName}
    >
      <SideQuestListCard
        tag={TAGS[0]}
        title={CARDS[0].title}
        items={data.card1?.items || []}
        onChange={(items) => handleCardChange('card1', 'items', items)}
        placeholder={CARDS[0].placeholder}
        readOnly={readOnly}
        isClosed={isClosed}
        managerNote={managerNotes.card1 || ''}
        onManagerNoteChange={(v) => onManagerNoteChange?.({ ...managerNotes, card1: v })}
        onSuggestManagerNote={createSuggestHandler?.('sideQuests', 'card1')}
        isManager={isManager}
        isReady={isReady}
        isShared={isShared}
      />

      {CARDS.slice(1).map((card, i) => (
        <FreeTextCard
          key={card.key}
          tag={TAGS[i + 1]}
          title={card.title}
          value={data[card.key]?.text || ''}
          onChange={(v) => handleCardChange(card.key, 'text', v)}
          placeholder={card.placeholder}
          readOnly={readOnly}
          isClosed={isClosed}
          managerNote={managerNotes[card.key] || ''}
          onManagerNoteChange={(v) => onManagerNoteChange?.({ ...managerNotes, [card.key]: v })}
          onSuggestManagerNote={createSuggestHandler?.('sideQuests', card.key)}
          isManager={isManager}
          isReady={isReady}
          isShared={isShared}
        />
      ))}
    </ReflectionTrack>
  )
}
